import React from "react";
import "./loading-screen.css";
//Components

class LoadingScreen extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      width: 0,
    };
  }

  componentDidMount() {}

  checkAndUseCMSData(data) {}

  render() {
    return (
      <div id="loader" className={this.props.className}>
        <div className="bg"></div>
        <div className="load_message">Loading...</div>
        <div className="loading_bar">
          <div
            className="load_progress"
            style={{ width: this.props.progress + "%" }}
          ></div>
        </div>
      </div>
    );
  }
}

export default LoadingScreen;
